var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import BaseCtrl from 'edge/platform/base/BaseCtrl';
import assert from 'assert';
import _ from 'underscore';

var Tile = function () {
    function Tile(displaykey, icon, color) {
        _classCallCheck(this, Tile);

        this._displaykey = displaykey;
        this._icon = icon;
        this._color = color;
    }

    _createClass(Tile, [{
        key: 'getDisplaykey',
        value: function getDisplaykey() {
            return this._displaykey;
        }
    }, {
        key: 'getColor',
        value: function getColor() {
            return this._color;
        }
    }, {
        key: 'getIcon',
        value: function getIcon() {
            return this._icon;
        }
    }]);

    return Tile;
}();

var Filter = function () {
    function Filter(tile) {
        _classCallCheck(this, Filter);

        assert(tile instanceof Tile);

        this._tile = tile;
        this._isActive = false;

        var that = this;
        this._patchLoadMethod = _.memoize(function (producerCode, loadMethod) {
            // Need to memoize, otherwise watcher looking for loadMethod would fire in an infinite loop
            return !loadMethod ? undefined : function () {
                return loadMethod.apply(this, arguments).then(function (data) {
                    that._firstLoadDeferred.resolve();
                    return data;
                }, function (err) {
                    // Reject the promise first load promise, rethrow.
                    that._firstLoadDeferred.reject();
                    throw err;
                });
            };
        });
    }

    _createClass(Filter, [{
        key: 'getTile',
        value: function getTile() {
            return this._tile;
        }
    }, {
        key: 'getLoadMethod',
        value: function getLoadMethod() {
            // Need the producer code to memoize against, because function body
            // may be the same coming from the load method, so is not suitable for the unique key
            return this._patchLoadMethod(this._producerCode, this._getLoadMethod());
        }
    }, {
        key: 'updateLoaders',
        value: function updateLoaders(producerCode, firstLoadDeferred) {
            this._producerCode = producerCode;
            this._firstLoadDeferred = firstLoadDeferred;
            return this._updateLoaders(producerCode);
        }
    }, {
        key: 'setActive',
        value: function setActive() {
            this._isActive = true;
        }
    }, {
        key: 'setInactive',
        value: function setInactive() {
            this._isActive = false;
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this._isActive;
        }
    }], [{
        key: '_getLoadMethod',
        value: function _getLoadMethod() {
            throw new Error('Should be overwritten by child class');
        }
    }, {
        key: '_updateLoaders',
        value: function _updateLoaders() {
            throw new Error('Should be overwritten by child class');
        }
    }]);

    return Filter;
}();

var QuickFilters = function () {
    function QuickFilters() {
        _classCallCheck(this, QuickFilters);

        this._filters = _.toArray(arguments);
        assert(this._filters.every(function (filter) {
            return filter instanceof Filter;
        }));

        var firstLoadDeferred = {};
        this._firstLoadDeferred = firstLoadDeferred;
        this._firstLoadPromise = new Promise(function (resolve, reject) {
            firstLoadDeferred.resolve = _.once(resolve);
            firstLoadDeferred.reject = _.once(reject);
        });

        this._producerCode = null;

        this.setActive(this._filters[0]);
    }

    _createClass(QuickFilters, [{
        key: 'getFirstLoadPromise',
        value: function getFirstLoadPromise() {
            return this._firstLoadPromise;
        }
    }, {
        key: 'getFilters',
        value: function getFilters() {
            return this._filters;
        }
    }, {
        key: 'getActive',
        value: function getActive() {
            return _.find(this._filters, function (filter) {
                return filter.isActive();
            });
        }
    }, {
        key: 'setActive',
        value: function setActive(filter) {
            assert(this._filters.indexOf(filter) > -1);
            this._filters.forEach(function (f) {
                return f.setInactive();
            });

            filter.setActive();
            this._updateCurrentFilterLoaders();
        }
    }, {
        key: 'updateProducerCode',
        value: function updateProducerCode(producerCode) {
            this._producerCode = producerCode;
            this._updateCurrentFilterLoaders();
        }
    }, {
        key: '_updateCurrentFilterLoaders',
        value: function _updateCurrentFilterLoaders() {
            if (this._producerCode) {
                this.getActive().updateLoaders(this._producerCode, this._firstLoadDeferred);
            }
        }
    }]);

    return QuickFilters;
}();

var Controller = function Controller($scope, ClaimService, gatewayParamConfig) {
    function processClaims(claims) {
        var maxNumberOfResults = claims.maxNumberOfResults;
        claims = Array.isArray(claims) ? claims : claims.claims;

        $scope.showWholeList = false; // Needed for all filters except recently viewed

        return {
            'items': claims.map(function (claim) {
                return {
                    'status': claim.state,
                    'isDraft': claim.stateCode === 'draft',
                    'product': claim.product,
                    'claimNumber': claim.claimNumber,
                    'lossDate': claim.dateOfLoss,
                    'policyNumber': claim.policyNumber,
                    'accountNumber': claim.accountNumber,
                    'accountIsPersonal': claim.isPersonalAccount,
                    'accountName': claim.insuredName,
                    'totalPayments': claim.totalPayments,
                    'totalIncurredNet': claim.totalIncurredNet
                };
            }),
            'maxNumberOfResults': maxNumberOfResults
        };
    }

    var RecentlyViewedFilter = function (_Filter) {
        _inherits(RecentlyViewedFilter, _Filter);

        function RecentlyViewedFilter() {
            _classCallCheck(this, RecentlyViewedFilter);

            return _possibleConstructorReturn(this, (RecentlyViewedFilter.__proto__ || Object.getPrototypeOf(RecentlyViewedFilter)).call(this, new Tile('gateway.views.claims-landing.Recently Viewed', 'fa-eye', 'gw-tile-color-8')));
        }

        _createClass(RecentlyViewedFilter, [{
            key: '_updateLoaders',
            value: function _updateLoaders() {
                this._load = function () {
                    // Producer code is irrelevant here
                    return ClaimService.getRecentlyViewedClaims().then(processClaims).then(function (data) {
                        $scope.showWholeList = true; // There's no pagination on recently viewed
                        data.maxNumberOfResults = data.items.length;
                        return data;
                    });
                };
            }
        }, {
            key: '_getLoadMethod',
            value: function _getLoadMethod() {
                return this._load;
            }
        }]);

        return RecentlyViewedFilter;
    }(Filter);

    var RecentlyCreatedFilter = function (_Filter2) {
        _inherits(RecentlyCreatedFilter, _Filter2);

        function RecentlyCreatedFilter() {
            _classCallCheck(this, RecentlyCreatedFilter);

            return _possibleConstructorReturn(this, (RecentlyCreatedFilter.__proto__ || Object.getPrototypeOf(RecentlyCreatedFilter)).call(this, new Tile('gateway.views.claims-landing.Recently Created', 'fa-calendar', 'gw-tile-color-8')));
        }

        _createClass(RecentlyCreatedFilter, [{
            key: '_updateLoaders',
            value: function _updateLoaders(producerCode) {
                this._load = function (offsetStart, offsetEnd) {
                    var queryOptions = {
                        offsetStart: offsetStart,
                        offsetEnd: offsetEnd,
                        orderBy: 'CreateTime',
                        orderByDescending: true
                    };

                    var getClaims = producerCode === 'all' ? ClaimService.getClaimsForCurrentUser(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions) : ClaimService.getClaimsForProducerCode(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions, producerCode);

                    return getClaims.then(processClaims);
                };
            }
        }, {
            key: '_getLoadMethod',
            value: function _getLoadMethod() {
                return this._load;
            }
        }]);

        return RecentlyCreatedFilter;
    }(Filter);

    var AllOpenFilter = function (_Filter3) {
        _inherits(AllOpenFilter, _Filter3);

        function AllOpenFilter() {
            _classCallCheck(this, AllOpenFilter);

            return _possibleConstructorReturn(this, (AllOpenFilter.__proto__ || Object.getPrototypeOf(AllOpenFilter)).call(this, new Tile('gateway.views.claims-landing.Open Claims', 'fa-folder-open-o', 'gw-tile-color-8')));
        }

        _createClass(AllOpenFilter, [{
            key: '_updateLoaders',
            value: function _updateLoaders(producerCode) {
                this._load = function (offsetStart, offsetEnd) {
                    var queryOptions = {
                        offsetStart: offsetStart,
                        offsetEnd: offsetEnd,
                        orderBy: 'CreateTime',
                        orderByDescending: true
                    };

                    var getClaims = producerCode === 'all' ? ClaimService.getOpenClaimsForCurrentUser(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions) : ClaimService.getOpenClaimsForProducerCode(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions, producerCode);

                    return getClaims.then(processClaims);
                };
            }
        }, {
            key: '_getLoadMethod',
            value: function _getLoadMethod() {
                return this._load;
            }
        }]);

        return AllOpenFilter;
    }(Filter);

    var RecentlyClosedFilter = function (_Filter4) {
        _inherits(RecentlyClosedFilter, _Filter4);

        function RecentlyClosedFilter() {
            _classCallCheck(this, RecentlyClosedFilter);

            return _possibleConstructorReturn(this, (RecentlyClosedFilter.__proto__ || Object.getPrototypeOf(RecentlyClosedFilter)).call(this, new Tile('gateway.views.claims-landing.Closed Claims', 'fa-lock', 'gw-tile-color-8')));
        }

        _createClass(RecentlyClosedFilter, [{
            key: '_updateLoaders',
            value: function _updateLoaders(producerCode) {
                this._load = function (offsetStart, offsetEnd) {
                    var queryOptions = {
                        offsetStart: offsetStart,
                        offsetEnd: offsetEnd,
                        orderBy: 'CreateTime',
                        orderByDescending: true
                    };

                    var getClaims = producerCode === 'all' ? ClaimService.getClosedClaimsForCurrentUser(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions) : ClaimService.getClosedClaimsForProducerCode(gatewayParamConfig.claimsCreatedInLastXDays, queryOptions, producerCode);

                    return getClaims.then(processClaims);
                };
            }
        }, {
            key: '_getLoadMethod',
            value: function _getLoadMethod() {
                return this._load;
            }
        }]);

        return RecentlyClosedFilter;
    }(Filter);

    var ctrl = Object.create(BaseCtrl);

    $scope.quickFilters = new QuickFilters(new RecentlyViewedFilter(), new RecentlyCreatedFilter(), new AllOpenFilter(), new RecentlyClosedFilter());

    $scope.initialLoading = $scope.quickFilters.getFirstLoadPromise();

    $scope.selectedProducerCode = null; // For producer code select
    $scope.$watch('selectedProducerCode', _.after(2, function (producerCode) {
        return $scope.quickFilters.updateProducerCode(producerCode.code);
    }));

    $scope.pageSize = gatewayParamConfig.claimsLandingResultsPerPage;

    return ctrl.create($scope);
};

Controller.$inject = ['$scope', 'claim.ClaimService', 'gatewayParamConfig'];
export default Controller;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/ClaimsLandingCtrl.js
// module id = 1667
// module chunks = 0